<template>
    <div>
        <template>
            <h4 class="not-margin" :style="{ marginTop: '10px' }">
                <img src="../../../../assets/delete-trash.png" class="img-delete">
            </h4>
        </template>

        <div class="con-content" :style="{ marginTop: '5px' }">
            <p :style="{ fontSize: '18px', color: '#195BFF' }">
                ກະລຸນາກົດຢືນຢັນ ເພື່ອຢືນຢັນການລຶບທີ່ຢູ່ນີ້
            </p>
        </div>

        <template>
            <div class="con-footer" :style="{ marginTop: '25px' }">
                <vs-button :loading="loading" transparent :style="{ color: 'crimson' }" @click="DeleteItem(shippingAddressId)">
                    ຢືນຢັນ
                </vs-button>
                <vs-button @click="$emit('close')" dark transparent>
                    ຍົກເລີກ
                </vs-button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: ['shippingAddressId'],
    data: () => ({
        loading: false,
    }),
    methods: {
        DeleteItem(id) {
            this.loading = true;
            this.$http.delete('shipping-address/' + id).then(res => {
                if (res.data && res.data.error === false) {
                    setTimeout(() => {
                        this.loading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_DeleteItem_OnSuccess('top-right', 'danger', 3000);
                    }, 200);
                } else {
                    this.loading = false;
                    this.$emit('close');
                    this.$notification.OpenNotification_DeleteItem_OnUnSuccess('top-right', 'danger', 3000);
                }
            }).catch(() => {
                this.loading = false;
                this.$emit('close');
                this.$notification.OpenNotification_DeleteItem_OnUnSuccess('top-right', 'danger', 3000);
            });
        },
    },
};
</script>
